var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('flat-pickr',{staticClass:"appup-datetime form-control",class:{'border border-danger': _vm.state==false },attrs:{"id":_vm.id,"config":_vm.config},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/inputs/datetime/datetime.vue